import searchPopupCustomComp from "./SearchPopup";
import fileUploadCustomComp from "./FileUpload";

export default {
  searchPopupCustomComp,
  fileUploadCustomComp
};